import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=084ca6a2"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=084ca6a2&prod&sc=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports